import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import whatsappIcon from './images/whatsapp-icon.svg';

const WhatsApp = (props) => {

  useEffect(() => {

  }, []);

  return (
    <div className='sale-whatsapp-wrapper'>
      <div className='whatsapp-icon' style={{backgroundImage:whatsappIcon.bg()}}></div>
      <div className='whatsapp-title'>
        הסיב שלנו יגיע בקרוב עד אליך
      </div>
      <div className='whatsapp-sub-title'>
        איך נוח לך שנמשיך?
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    //leadType: state.saleJetBlock.leadType,
    //other states
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatsApp);
